import React, { Component } from 'react';
import { ieCheck } from '../../../helpers/utils';
import _filter from 'lodash/filter';
import Slider from "react-slick";
import { strCount } from '../../../helpers/stringutils';

const  NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-wrapper arrow-wrapper-next" onClick={onClick}>
    <div
      className={className}
      style={{ ...style, display: "block" }}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
        <path d="M17.525 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L205.947 256 10.454 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L34.495 36.465c-4.686-4.687-12.284-4.687-16.97 0z"/>
      </svg>
  </div>
  </div>
  );
}

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div className="arrow-wrapper arrow-wrapper-prev" onClick={onClick}>
      <div
        className={className}
        style={{ ...style, display: "block" }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
          <path d="M238.475 475.535l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L50.053 256 245.546 60.506c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0L10.454 247.515c-4.686 4.686-4.686 12.284 0 16.971l211.051 211.05c4.686 4.686 12.284 4.686 16.97-.001z"/>
        </svg>
      </div>
    </div>
  );
}

const SLICK_SETTINGS = {
  cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
  arrows:true,
  prevArrow:<PrevArrow  />,
  nextArrow:<NextArrow />,
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll:3,
  initialSlide: 0,
  responsive: [
   {
     breakpoint: 1024,
     settings: {
       slidesToShow: 3,
       slidesToScroll: 1,
       arrows:false
     }
   },
   {
     breakpoint: 700,
     settings: {
       slidesToShow: 2,
       slidesToScroll: 1,
       arrows:false
     }
   },
   {
     breakpoint: 480,
     settings: {
       slidesToShow: 1,
       slidesToScroll: 1,
       arrows:false
     }
   }
 ]
}


class ItinerarySlider extends Component{


  durationText(duration, i, arr){
    if(i === 0){
      return "Start City";
    }
    else if(i === arr.length - 1){
      return 'End City'
    }else{
      return duration + "  days";
    }
  }

  isOptional(optional){
    return optional ? <strong>*</strong> : null;
  }


  render(){

    const { sequenceWithImage, destination } = this.props;

    const imageObj = {
      imageQuality:60
    }

    const imageURL = (img) => {
      return (img !== undefined) ? _filter(img, {'title': 'hero'})[0].url : ""
     }

    const standardImg = (img, descriptionLong, description, type) => {
      return (
        <div className="image-wrapper">
          <img
            alt=""
            data-srcset={`https:${imageURL(img)}?w=498&q=${imageObj.imageQuality} 1x,
            https:${imageURL(img)}?w=698&q=${imageObj.imageQuality} 2x`}
            data-src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            className="lazyload" />
            <div className={`itinerary-overlay ${type}`}>
              <h4 className="busabout-h4-alt">{description}</h4>
              <p className={`busabout-h4-alt ${strCount(descriptionLong, 565, "small")}`} >{descriptionLong}</p>
            </div>
        </div>
      )
    }

    const ieImg = (img) => {
      return (
        <div className="image-wrapper">
          <img alt="" src={`https:${imageURL(img)}?w=698&q=${imageObj.imageQuality}`} />
        </div>
      )
    }

    return (
      <Slider {...SLICK_SETTINGS} ref={slider => (this.slider = slider)} class="busabout-slider">
        {
          sequenceWithImage.map((item, i) => {
            return (
              <div key={i} className={`itinerary-slide-wrapper ${item.type} ${destination}`}>
                <div className={`circle-dot ${(i === 0) ? 'start-dot' : ''}`}><span>{i}</span></div>
                <hr/>
                <div className="itinerary-slide-item">
                  <svg xmlns="http://www.w3.org/2000/svg" width="56.855" height="73.589" viewBox="0 0 56 73">
                    <g data-name="Layer 2">
                      <g data-name="Layer 1">
                        <path d="M28.428 40.957a15.61 15.61 0 1 1 15.61-15.61 15.628 15.628 0 0 1-15.61 15.61zm0-27.22a11.61 11.61 0 1 0 11.61 11.61 11.623 11.623 0 0 0-11.61-11.61z"/>
                        <path d="M28.428 34.151a8.805 8.805 0 1 1 8.804-8.804 8.815 8.815 0 0 1-8.804 8.804zm0-13.61a4.805 4.805 0 1 0 4.804 4.806 4.812 4.812 0 0 0-4.804-4.806z"/>
                        <path d="M38.283 61.345a2 2 0 0 1-1.618-3.173c3.49-4.818 12.883-18.196 14.43-22.18a22.51 22.51 0 0 0 1.76-7.93c0-7.12-2.524-13.455-7.11-17.842a23.078 23.078 0 0 0-17.23-6.192q-.087.003-.175 0a23.133 23.133 0 0 0-17.23 6.193C6.524 14.607 4 20.943 4 28.063a20.882 20.882 0 0 0 1.295 6.663c1.46 4.231 12.03 18.319 15.978 23.39a2 2 0 0 1-3.156 2.457C16.622 58.654 3.457 41.656 1.514 36.03A24.792 24.792 0 0 1 0 28.063C0 19.842 2.963 12.479 8.344 7.33A27.08 27.08 0 0 1 28.428.028 27.017 27.017 0 0 1 48.51 7.33c5.38 5.148 8.343 12.512 8.343 20.732a26.408 26.408 0 0 1-2.03 9.377c-2.05 5.278-14.394 22.354-14.919 23.079a1.998 1.998 0 0 1-1.622.827zM28.428 73.589a2 2 0 0 1-1.414-.586L21.36 67.35a2 2 0 0 1 2.828-2.828l4.24 4.24 4.238-4.24a2 2 0 0 1 2.828 2.828l-5.652 5.653a2 2 0 0 1-1.414.586z"/>
                      </g>
                    </g>
                  </svg>
                  <p className="city-text bold no-margin display-line-block">{item.city} {this.isOptional(item.optional)}</p>
                  <p className="day-text">{this.durationText(item.duration, i, this.props.sequenceWithImage)}</p>
                  { ieCheck() ? ieImg(item.images)  : standardImg(item.images, item.descriptionLong, item.description, item.type) }
                </div>
              </div>
            )
          })
        }
      </Slider>
    )
  }
}


export default ItinerarySlider;



// WEBPACK FOOTER //
// ./src/components/preview/components/itinerarySlider.js